<template>
    <el-dialog :title="returnsSingle ? '变更申请详情' : '合同详情'" :visible.sync="isdetails" width="1200px" :before-close="handleClose" :close-on-click-modal="false">
        <div class="hw-content">
            <el-collapse v-model="activeNames">
                <el-collapse-item title="合同信息" name="1">
                    <div>
                        <el-button type="primary" v-for="item in buttonList" v-if="item.value == '可用'" :key="item.name" @click="buttonDispose(item.name)">{{ item.name }}</el-button>
                    </div>

                    <el-table :data="orderList" style="width: 300px; margin-top: 10px" border :show-header="false">
                        <el-table-column prop="title" label="title" align="right" width="100">
                            <template v-slot="scope">
                                <span>{{ scope.row.title }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="value" label="value">
                            <template v-slot="scope">
                                <span v-if="scope.$index == 2 && scope.row.value">{{ scope.row.value | formatDates }}</span>
                                <span v-else>{{ scope.row.value }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-collapse-item>

                <el-collapse-item title="订单基本信息" name="1" v-if="returnsSingle">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="合同号">
                            <div class="rows">{{ result.Detail.BackBill_SN }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="下单时间">
                            <div class="rows">{{ result.Detail.BackBill_AddTime | formatDate }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="报价单编号">
                            {{ result.Detail.BackBill_OrdersERPSN }}
                        </el-descriptions-item>
                        <el-descriptions-item label="合同类型">
                            {{ result.Detail.Orders_SPCOrdersSN }}
                        </el-descriptions-item>
                        <el-descriptions-item label="审核状态">
                            {{ result.Detail.BackBill_ContractPaperSN }}
                        </el-descriptions-item>
                        <el-descriptions-item label="BPM审核状态">{{ result.Detail.BackBill_ERPSN }}</el-descriptions-item>
                        <el-descriptions-item label="合同纸回收状态">{{ result.Detail.Office_Name }}</el-descriptions-item>
                        <el-descriptions-item label="电子签章状态">{{ result.Detail.Orders_OfficeMan }}</el-descriptions-item>
                        <el-descriptions-item label="办事处">{{ result.Detail.BackBill_CustomerCode }}</el-descriptions-item>
                        <el-descriptions-item label="业务员">{{ result.Detail.BackBill_CustomerName }}</el-descriptions-item>
                        <el-descriptions-item label="工程名称">{{ result.Detail.Orders_ProjectName }}</el-descriptions-item>
                        <el-descriptions-item label="工程地址">{{ result.Detail.BackBillSyncStatusName }}(RMA：{{ result.Detail.RMAName }})</el-descriptions-item>
                        <el-descriptions-item label="行业分类">{{ result.Detail.BackBillStatusName }}</el-descriptions-item>
                        <el-descriptions-item label="是否开具红冲发票">
                            <span :class="judgeColor(result.Detail.RecoverStatusName)">{{ result.Detail.AttachmentAuditName }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="配送方式	">
                            <span :class="judgeColor(result.Detail.RecoverStatusName)">{{ result.Detail.RecoverStatusName }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="支付方式">
                            <span :class="judgeColor(Orders_ESignStatus)">{{ Orders_ESignStatus }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="发货类型">
                            <span :class="judgeColor(Orders_ESignStatus)">{{ Orders_ESignStatus }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="发货方式">
                            <span :class="judgeColor(Orders_ESignStatus)">{{ Orders_ESignStatus }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="是否缺货合同">
                            <span :class="judgeColor(Orders_ESignStatus)">{{ Orders_ESignStatus }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="交货时间">
                            <span :class="judgeColor(Orders_ESignStatus)">{{ Orders_ESignStatus }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="短信通知">
                            <span :class="judgeColor(Orders_ESignStatus)">{{ Orders_ESignStatus }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="免盖章">
                            <span :class="judgeColor(Orders_ESignStatus)">{{ Orders_ESignStatus }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="纸质合同号">
                            <span :class="judgeColor(Orders_ESignStatus)">{{ Orders_ESignStatus }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="期望交货时间">
                            <span :class="judgeColor(Orders_ESignStatus)">{{ Orders_ESignStatus }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="合同其他约定">
                            <span :class="judgeColor(Orders_ESignStatus)">{{ Orders_ESignStatus }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="合同备注">
                            <span :class="judgeColor(Orders_ESignStatus)">{{ Orders_ESignStatus }}</span>
                        </el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>

                <el-collapse-item title="原订单信息" name="1" v-if="returnsSingle">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="原ERP单号">
                            <div class="rows">{{ result.Orders_Address_Name }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="原订单金额">
                            <div class="rows">{{ result.Orders_Address_Phone_Number }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="原业务员">
                            {{ result.Orders_Address_Mobile }}
                        </el-descriptions-item>
                        <el-descriptions-item label="原合同纸号">
                            {{ result.addressinfo }}
                        </el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>

                <el-collapse-item title="电子签章" name="2" v-if="orderDetails.Orders_ESignStatus > 0">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="签章状态">
                            <div class="rows">
                                <span :class="judgeColor(Orders_ESignStatus)">{{ Orders_ESignStatus }}</span>
                            </div>
                        </el-descriptions-item>
                        <el-descriptions-item label="联系人">
                            <div class="rows">{{ orderDetails.Orders_ESignName }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="联系人手机">
                            <div class="rows">{{ orderDetails.Orders_EsignMobile }}</div>
                        </el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>

                <el-collapse-item title="退货清单" name="3">
                    <el-table :data="result.Goods" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" show-summary>
                        <el-table-column prop="Goods_Product_Code" label="商品编码" align="center"></el-table-column>
                        <el-table-column prop="Goods_Product_Name" label="商品名称" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="Goods_Product_SourcePrice" label="原始价格" align="center">
                            <template v-slot="scope">
                                <span class="is-status-text">￥ {{ getFloat(scope.row.Goods_Product_SourcePrice) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Goods_Product_Price" label="申请价格" align="center">
                            <template v-slot="scope">
                                <span class="is-status-text">￥ {{ getFloat(scope.row.Goods_Product_Price) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Goods_Product_Amount" label="数量" align="center"></el-table-column>
                        <el-table-column prop="Goods_Product_SourcePrice" label="合计" align="center">
                            <template v-slot="scope">
                                <div class="is-status-text">
                                    {{ getFloat(Number((scope.row.Goods_Product_Price * scope.row.Goods_Product_Amount).toFixed(2))) }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Goods_RMALineNo" label="退货行号" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="SyncStatusName" label="同步状态" align="center">
                            <template v-slot="scope">
                                <span :class="judgeColor(scope.row.SyncStatusName)">{{ scope.row.SyncStatusName }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="margin-top: 10px">
                        合计： ￥
                        <span class="is-status-text">{{ getFloat(returnGoodesPorductPirce) }}</span>
                    </div>
                </el-collapse-item>

                <el-collapse-item title="合同附件" name="4">
                    <el-table :data="result.Attachment" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                        <el-table-column prop="No" label="序号" align="center" width="80">
                            <template v-slot="scope">
                                {{ scope.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="Attachment_Source" label="附件文件" align="center" width="300" show-overflow-tooltip>
                            <template v-slot="scope">
                                <span class="operation-bar-block" @click="downFile(scope.row.Attachment_Path)">{{ scope.row.Attachment_Source }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Attachment_AuditNote" label="审核备注" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="Attachment_Addtime" label="上传时间" align="center" width="150">
                            <template v-slot="scope">
                                {{ scope.row.Attachment_Addtime | formatDates }}
                            </template>
                        </el-table-column>
                    </el-table>
                </el-collapse-item>
                <el-collapse-item title="查看历史附件" name="5" v-if="result.IsShowHistory">
                    <el-table :data="History" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                        <el-table-column prop="No" label="序号" align="center" width="80">
                            <template v-slot="scope">
                                {{ scope.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="Attachment_Source" label="附件文件" align="center" width="300" show-overflow-tooltip>
                            <template v-slot="scope">
                                <span class="operation-bar-block" @click="downFile(scope.row.Attachment_Path)">{{ scope.row.Attachment_Source }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Attachment_AuditNote" label="审核备注" align="center" show-overflow-toolti></el-table-column>
                        <el-table-column prop="Attachment_Addtime" label="上传时间" align="center" width="150">
                            <template v-slot="scope">
                                {{ scope.row.Attachment_Addtime | formatDates }}
                            </template>
                        </el-table-column>
                    </el-table>
                </el-collapse-item>
            </el-collapse>
        </div>
        <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center">
            <el-button @click="handleClose">返回</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    props: {
        isdetails: {
            type: Boolean,
            default: false
        },
        id: {
            type: Number,
            default: 272
        }
    },
    data() {
        return {
            Orders_Status: '',
            orderList: [
                { title: '合同号', value: '' },
                { title: '合同状态', value: '' },
                { title: '下单时间', value: '' }
            ],
            sMDSPipelineShow: false, // 展示关联商机信息
            returnsSingle: false, //是否为仅退货
            sMDSPipelineData: {}, // 关联商机信息
            OrdersSourceCate: 0, //订单类型，0报价单1合同变更2独立合同
            Orders_CreditInvoiceStatus: '', //是否开具红冲发票
            details: {},
            activeNames: ['1', '2', '3', '4', '5'],
            orderDetails: { Orders_ESignStatus: 0, Orders_ESignName: '', Orders_EsignMobile: '' }, //合同详情，用来判断电子签章是否显示
            Orders_ESignStatus: '',
            returnGoodesPorductPirce: 0,
            result: {
                Detail: {
                    Office_Name: '',
                    Orders_OfficeMan: '',
                    Orders_SPCOrdersSN: '',
                    BackBillSyncStatusName: '',
                    BackBillStatusName: '',
                    AttachmentAuditName: '',
                    RecoverStatusName: '',
                    RMAName: '--',
                    Orders_ProjectName: '',
                    BackBill_AddTime: '',
                    BackBill_AttachmentAudit: 1,
                    BackBill_AttachmentAudit_Time: '',
                    BackBill_ContractPaperSN: '',
                    BackBill_CustomerCode: '',
                    BackBill_CustomerID: 279,
                    BackBill_CustomerName: '',
                    BackBill_ERPSN: '',
                    BackBill_ID: 9,
                    BackBill_OfficeCode: '',
                    BackBill_OfficeID: 191,
                    BackBill_OfficeManCode: '',
                    BackBill_OfficeManID: 54,
                    BackBill_OrdersERPSN: '',
                    BackBill_RMA: 0,
                    BackBill_RecoverStatus: 0,
                    BackBill_SN: '',
                    BackBill_SPCOrdersID: 342,
                    BackBill_Status: 1,
                    BackBill_SyncStatus: 0,
                    BackBill_SyncTime: '',
                    BackBill_TotalPrice: 90.65
                },

                Goods: [],
                Attachment: [],
                IsUpload: false,
                IsShowHistory: false
            },
            History: [],
            returnGoodsList: [], //关联退货单
            ReturnGoodsId: [], //当前选中的批量操作退货单id
            returnGoodsdeDetailList: '', //退货清单
            returnGoodsdePirce: '', //退货清单总金额

            buttonList: [], //订单详情按钮
        };
    },
    watch: {
        isdetails(newval, oldval) {
            if (newval) {
                this.getOrderDetails(this.id);
            }
        }
    },
    mounted() {
     
    },
    methods: {
        // 获取订单详情
        async getOrderDetails() {
            var result = await this.$newsApi.order.getSPCOrdersByID({
                ID: this.id
            });
            const orderInfo = result.data.data;
            if (orderInfo.Orders_Status == -1) {
                this.$message({
                    type: 'warning',
                    title: '临时合同不可查看详情'
                });
                return;
            }
            if (orderInfo.Extend && orderInfo.Extend.Orders_SMDSPipelineID) {
                this.sMDSPipelineShow = true;
                this.sMDSPipelineData = JSON.parse(orderInfo.Extend.Orders_SMDSPipelineInfo);
                console.log(this.sMDSPipelineData);
            }

            orderInfo.addressDetails = '';
            orderInfo.projectDetails = '';
            this.orderDetails = orderInfo;

            // if (orderInfo.Orders_CustomerSubID > 0) {
            // 	// 存在二级客户
            // 	await this.GetCustomerSubByID(result.data.Orders_CustomerSubID);
            // }

            this.OrdersSourceCate = orderInfo.Orders_SourceCate;
            // 退货单
            if (this.OrdersSourceCate == 1) {
                this.returnsSingle = this.OrdersSourceCate == 1 ? true : false;
                let orderRequests = [
                    this.GetCreditInvoiceStatus(orderInfo.Orders_CreditInvoiceStatus), //红冲发票
                    this.GetSPCOrdersRelateBackBillList(), //关联退款单
                    this.GetSPCOrdersBackGoodsByOrdersID(), //退货清单
                    this.GetOrderDetailButton(orderInfo) //订单详情按钮
                ]
                await Promise.all(orderRequests);
            }

            await this.GetOrdersStatus(orderInfo);
        },
         // 订单按钮操作统一处理
         buttonDispose(e) {
            switch (e) {
                case '取消':
                    this.userCancle();
                    break;
                case '提交':
                    this.goSubmitOrder();
                    break;
                case '修改':
                    this.changeOrder();
                    break;
            }
        },
        userCancle() {
            this.$prompt('请输入取消原因', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /.+/,
                inputErrorMessage: '取消原因不能为空'
            }).then(({ value }) => {
                let data = {
                    Orders_ID: this.id,
                    Orders_CancelReason: value
                }
                this.$newsApi.order.SPCOrders_Cancel({json:JSON.stringify(data)}).then((res) => {
                    console.log(res);
                });
            });
        },
        goSubmitOrder() {
            console.log('提交');
        },
        
        //获取关联退货单
        async GetSPCOrdersRelateBackBillList() {
            let result = await this.$newsApi.order.getSPCOrdersRelateBackBillList({
                orders_id: this.id
            });
            if (result.data.data) {
                this.ReturnGoodsId = [];
                result.data.map((item) => (item.checked = true));
                result.data.map((item) => this.ReturnGoodsId.push(item.BackBill_ID));
                this.returnGoodsList = result.data.data;
            } else {
                this.returnGoodsList = [];
            }
        },
        //获取退货清单
        async GetSPCOrdersBackGoodsByOrdersID() {
            let result = await this.$newsApi.order.getSPCOrdersBackGoodsByOrdersID({
                orders_id: this.id
            });
            this.returnGoodsdeDetailList = result.data.data;
            this.returnGoodsdePirce = 0;
            if (result.data.data) {
                for (let i = 0; i < result.data.data.length; i++) {
                    const el = result.data.data[i];
                    this.returnGoodsdePirce += Number((el.Goods_Product_Price * el.Goods_Product_Amount).toFixed(2));
                }
                this.returnGoodsdePirce = this.returnGoodsdePirce.toFixed(2);
            }
        },

        //获取是否开具红冲发票
        async GetCreditInvoiceStatus(status) {
            let result = await this.$newsApi.order.getCreditInvoiceStatus({
                status: status
            });

            this.Orders_CreditInvoiceStatus = result.data.data;
        },
        //订单详情-获取订单状态
        async GetOrdersStatus(req) {
            let result = await this.$newsApi.order.getOrdersStatus({
                status: req.status
            });
            this.Orders_Status = result.data.data;
            this.orderList[0].value = req.Orders_SN;
            this.orderList[1].value = this.Orders_Status;
            this.orderList[2].value = req.Orders_Addtime;
        },
        /*
        关闭详情
        */
        handleClose() {
            this.$emit('handleClose');
        },
        /*
        打开文件
        */
        downFile(par, flag) {
            if (flag) {
                window.open(par);
                return;
            }
            this.$newsApi.common.getUrlPath().then((res) => {
                if (res.data.Resultcode == 0) {
                    let path = res.data.data;
                    let paths = path + par;
                    window.open(paths);
                }
            });
        },
        //获取订单详情按钮
		async GetOrderDetailButton(orderInfo) {
			var result = await this.$newsApi.order.SPCOrder_Detail_Button({
				Orders_ID: this.id,
				Orders_Status: orderInfo.Orders_Status,
				Orders_AuditStatus: orderInfo.Orders_Status,
				Orders_BPMAuditStatus: orderInfo.Orders_BPMAuditStatus,
				Orders_FreightType: orderInfo.Orders_FreightType,
				Orders_PrePay_Percent: orderInfo.Orders_PrePay_Percent,
				Orders_PaperContractSN: orderInfo.Orders_PaperContractSN,
				Orders_SourceCate: orderInfo.Orders_SourceCate,
				Orders_ESignStatus: orderInfo.Orders_ESignStatus,
				orders_sn:orderInfo.Orders_SN
			});
			var arr = [];
            result = result.data;
			if (result.data) {
				for (var key in result.data) {
					var obj = {};
					obj.name = key;
					obj.value = result.data[key];
					arr.push(obj);
				}
			}
			this.buttonList = arr;
		},
    }
};
</script>

<style lang="scss" scoped>
/* .hw-content 的样式 */
.hw-content {
    padding: 0 20px;
}

/* 通用样式 */
.rows {
    width: 389px;
}
</style>
